/* @flow */
import * as React from "react";

type State = {
  width: number,
  height: number,
  didMeasure: boolean
};

type Props = {
  children: (
    config: State & {
      innerRef: (node: ?HTMLElement) => void
    }
  ) => React.Node,
  onMeasure?: State => void
};

class Measure extends React.PureComponent<Props, State> {
  node: ?HTMLElement;

  state: State = {
    width: 0,
    height: 0,
    didMeasure: false
  };

  shouldMeasure = false;
  prevWidth = 0;
  prevHeight = 0;

  takeMeasurements = () => {
    if (this.shouldMeasure) {
      requestAnimationFrame(this.takeMeasurements);

      if (this.node != null) {
        const { clientWidth, clientHeight } = this.node;

        if (
          clientWidth !== this.prevWidth ||
          clientHeight !== this.prevHeight
        ) {
          this.prevWidth = clientWidth;
          this.prevHeight = clientHeight;

          if (this.props.onMeasure) {
            this.props.onMeasure({
              width: clientWidth,
              height: clientHeight,
              didMeasure: true
            });
          } else {
            this.setState({
              width: clientWidth,
              height: clientHeight,
              didMeasure: true
            });
          }
        }
      }
    }
  };

  registerRef = (node: HTMLElement) => {
    this.node = node;
  };

  componentDidMount() {
    this.shouldMeasure = true;
    this.takeMeasurements();
  }

  componentWillUnmount() {
    this.shouldMeasure = false;
  }

  render() {
    return this.props.children({
      innerRef: this.registerRef,
      ...this.state
    });
  }
}

export default Measure;



// WEBPACK FOOTER //
// ./src/components/common/Measure.js